import { Component, computed, Signal, signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { SectionHeaderComponent } from '../section-header/section-header.component';
import { CourseThemeService } from '../../../api/course-theme/course-theme.service';
import { CourseService } from '../../../api/course/course.service';
import { CourseCatalogueCardComponent } from '../../courses/course-catalogue/course-catalogue-card/course-catalogue-card.component';
import { CategoryCardSkeletonComponent } from './category-card-skeleton/category-card-skeleton.component';
import { toStatefulSignal } from '../../../util/stateful.signal';
import { i18nRouterLinkDirective } from '../../../util/router/i18n-router-link.directive';

@Component({
  selector: 'app-category-section',
  standalone: true,
  imports: [
    SectionHeaderComponent,
    CourseCatalogueCardComponent,
    CategoryCardSkeletonComponent,
    MatButtonModule,
    MatIconModule,
    i18nRouterLinkDirective,
  ],
  templateUrl: './category-section.component.html',
})
export class CategorySectionComponent {
  constructor(
    private themeService: CourseThemeService,
    private courseService: CourseService,
  ) {}

  public readonly categories: Signal<string[]> = toSignal(
    this.themeService.getAllCategories(),
    {
      initialValue: [],
    },
  );
  public readonly categoryList = computed(() =>
    this.expandCategories() ? this.categories() : this.categories().slice(0, 5),
  );
  public readonly expandCategories = signal(false);
  public readonly selectedCategory = signal<string | undefined>(undefined);

  public readonly courses = toStatefulSignal(
    (category) => this.courseService.getFeaturedCourses(9, category),
    {
      state: [toObservable(this.selectedCategory)],
      initialValue: [],
    },
  );

  public selectCategory(category: string) {
    this.selectedCategory.update((selectedCategory) =>
      category === selectedCategory ? undefined : category,
    );
  }
}
